import { render, staticRenderFns } from "./microtrends.vue?vue&type=template&id=2f6d7c3c"
import script from "./microtrends.vue?vue&type=script&lang=js"
export * from "./microtrends.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports